import styles from '../index.scss'
import { SafeArea } from 'antd-mobile'
import { DpButtonThemeConfig } from '@/libs/components'
import classnames from 'classnames'

export interface IDpBusinessCommodityToolBar {
  style?: React.CSSProperties
  btnStyle?: React.CSSProperties
  tipsStyle?: React.CSSProperties
  textStyle?: React.CSSProperties
  data?: {
    equity?: {
      equityCode: string
    }
    showTips?: boolean
    tips?: string
    exchangeType: string | number | undefined // 支付类型
    exchangePrice?: string // 价格
    pointPrice?: string | number | undefined // 兑换价格
    totalAmount: string | number // 兑换价格
    redeemUnit?: string // 租户单位
  }
  centerRender?: any
  onSubmit?: any
  buttonText?: string
  isTheme?: boolean // 是否主题，为了兼容JD的，不改动原来
  className?: any
  config?: {
    hasHiddenPrice?: Boolean | undefined
  }
}

export const TotalPriceRender = (props: any) => {
  switch (props?.data?.exchangeType) {
    case 1: // 现金
    case 8: // 现金 + 第三方权益
      return (
        <span>
          <span className={styles["dp-business-commodity--tool-unit"]}>￥</span>
          {props?.data?.totalAmount || 0}
        </span>
      )
    case 2: // 积分
      return (
        <span>
          {props?.data?.pointPrice || 0}
          <span className={styles["dp-business-commodity--tool-unit"]}> {props?.data?.redeemUnit || lang['积分']}</span>
        </span>
      )
    case 4: // 第三方权益
      return (
        <span>
          {props?.data?.pointPrice || 0}
          <span className={styles["dp-business-commodity--tool-unit"]}> {props?.data?.redeemUnit || lang['积分']}</span>
        </span>
      )
    case 5: // 现金 + 积分
      return (
        <span>
          {props?.data?.pointPrice || 0}
          <span className={styles["dp-business-commodity--tool-unit"]}> {props?.data?.redeemUnit || '积分'} + ￥</span>
          {props?.data?.totalAmount || 0}
        </span>
      )
    default:
      return ''
  }
}

const ToolSubmit = (props: IDpBusinessCommodityToolBar) => {
  const amountPrice = TotalPriceRender(props)
  return (
    <footer
      className={classnames(styles["dp-business-commodity--fixTool"], props?.className)}
      style={props?.style}>
      <div className={styles["dp-business-commodity--tool"]}>
        { props?.data?.showTips &&
          <p className={styles["dp-business-commodity--tool-tips"]} style={props?.tipsStyle}>{props?.data?.tips}</p>
        }
        {(amountPrice && !props?.config?.hasHiddenPrice) && (
          <div className={styles["dp-business-commodity--tool-total"]}> {lang['合计']}： <span style={props?.textStyle}>{amountPrice}</span></div>
        )}
        {props?.centerRender}
        <DpButtonThemeConfig
          buttonText={props?.buttonText || lang['提交']}
          isTheme={props?.isTheme}
          onClick={props?.onSubmit}
          style={{ ...props?.btnStyle, borderWidth: 0, flex: 1 }}
        />
      </div>
      <SafeArea position="bottom" />
    </footer>

  )
}

export default ToolSubmit
